'use client';

import Image from 'next/image';

const MissionVisionSection = () => {
  return (
    <section className="w-full bg-[#ffadc640]">
      <div className="w-full max-w-[1440px] mx-auto px-[28px] sm:px-[42px] md:px-[56px] py-[32px] sm:py-[48px] md:py-[64px]">
        <div className="flex flex-col md:flex-row justify-center items-start gap-8 md:gap-[100px] w-full lg:w-[88%] mx-auto">
          {/* Mission */}
          <div className="flex flex-col gap-[20px] sm:gap-[30px] md:gap-[40px] w-full md:flex-1">
            <Image
              src="/images/mission-icon.webp"
              alt="mission-icon"
              width={44}
              height={44}
              className="w-[22px] h-[22px] sm:w-[33px] sm:h-[33px] md:w-[44px] md:h-[44px]"
              unoptimized
            />
            <div className="flex flex-col gap-[8px] sm:gap-[12px] md:gap-[16px]">
              <h3 className="text-[18px] sm:text-[27px] md:text-[36px] font-medium leading-[18px] sm:leading-[27px] md:leading-[36px] text-left text-primary-background">
                Mission
              </h3>
              <p className="text-[14px] sm:text-[16px] md:text-md font-normal leading-[18px] sm:leading-[21px] md:leading-[24px] text-left text-text-muted w-full md:w-[92%]">
                We believe that the future of AI must be shaped by diverse voices. EmpowHER in AI provides a collaborative space for women founders, operators, and innovators driving meaningful change in AI.
              </p>
            </div>
          </div>

          {/* Vision */}
          <div className="flex flex-col gap-[20px] sm:gap-[30px] md:gap-[40px] w-full md:w-[44%] self-center">
            <Image
              src="/images/vision-icon.webp"
              alt="vision-icon"
              width={44}
              height={44}
              className="w-[22px] h-[22px] sm:w-[33px] sm:h-[33px] md:w-[44px] md:h-[44px]"
              unoptimized
            />
            <div className="flex flex-col gap-[8px] sm:gap-[12px] md:gap-[16px]">
              <h3 className="text-[18px] sm:text-[27px] md:text-[36px] font-medium leading-[18px] sm:leading-[27px] md:leading-[36px] text-left text-primary-background">
                Vision
              </h3>
              <p className="text-[14px] sm:text-[16px] md:text-md font-normal leading-[18px] sm:leading-[21px] md:leading-[24px] text-left text-text-muted w-full md:w-[96%]">
                We envision a future where women are not just participants but key decision-makers and architects of the AI revolution. A future where innovation is guided by inclusivity, equity, and authentic leadership.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default MissionVisionSection